import { gql } from '@apollo/client'

export const GET_FABRIC_PALETTES = gql`
  query GET_FABRIC_PALETTES(
    $searchTerm: String
    $take: Int
    $skip: Int
    $orderBy: [FabricPaletteOrderByWithRelationInput!]
  ) {
    findManyFabricPaletteCount(
      where: { OR: [{ name: { mode: insensitive, contains: $searchTerm } }, { code: { mode: insensitive, contains: $searchTerm } }] }
    )
    findManyFabricPalette(
      orderBy: $orderBy
      where: { OR: [{ name: { mode: insensitive, contains: $searchTerm } }, { code: { mode: insensitive, contains: $searchTerm } }] }
      take: $take
      skip: $skip
    ) {
      id
      name
      code
      createdAt

      _count {
        fabric_groups
      }
    }
  }
`

export const DELETE_MANY_FABRIC_PALETTES = gql`
  mutation DELETE_MANY_FABRIC_PALETTES($ids: [Int!]!) {
    deleteManyFabricPalette(where: { id: { in: $ids } }) {
      count
    }
  }
`

export const CREATE_FABRIC_PALETTE = gql`
  mutation CREATE_FABRIC_PALETTE($name: String!, $code: String, $fabric_groups: [Int!]!) {
    createFabricPalette(
      data: {
        name: $name
        code: $code
        fabric_groups: { connect: { id: { in: $fabric_groups } } }
      }
    ) {
      id
      name
      code
    }
  }
`

export const UPDATE_FABRIC_PALETTE = gql`
  mutation UPDATE_FABRIC_PALETTE(
    $where: FabricPaletteWhereUniqueInput!
    $name: String!
    $code: String
    $fabric_groups_with_names: [FabricGroupWithNameInput!]
  ) {
    updateFabricPalette(
      where: $where
      name: $name
      code: $code
      fabric_groups_with_names: $fabric_groups_with_names
    ) {
      id
      createdAt
      name
      code
    }
  }
`

export const GET_FABRIC_PALETTE = gql`
  query GET_FABRIC_PALETTE($id: Int!) {
    findUniqueFabricPalette(where: { id: $id }) {
      id
      name
      code
      updatedAt
      fabric_groups {
        id
        name
        fabric_group {
          id
          code
          fabric_group_profiles {
            name
            language
          }
        }
      }
    }
  }
`
